import { IState } from '../../../../store/types';
import { connect } from 'react-redux';
import { BackToSelected } from '../component/BackToSelected';
import { IBackToSelectedEvents, IBackToSelectedFields } from '../component/types';
import { CaptionsSelectionPopupSelectors } from '../../../../store/captions-selection-popup/selectors';
import { PhraseDetailsSelectors } from '../../../../store/phrase-details/selectors';

const mapStateToProps = (
	dispatch: any
) => {
	return (
		state: IState
	): IBackToSelectedFields => {
		const phraseId = PhraseDetailsSelectors.getPhraseId(state);
		let captionIndex = CaptionsSelectionPopupSelectors.getCurrentSelection(state).captionIndex;
		if (captionIndex === undefined) captionIndex = -1;
		const selectResult = CaptionsSelectionPopupSelectors.getSelectResult(state) || null;
		const isShow = !!selectResult?.elementId && !!phraseId ||
			captionIndex >= 0;

		return {
			isShow,
			selectResult,
			captionIndex,
		}
	};
}

const mapDispatchToProps = (
	dispatch: any
): IBackToSelectedEvents => ({
});

export const BackToSelectedHOC = connect(
	mapStateToProps,
	null
)(BackToSelected) as any;

BackToSelectedHOC.displayName = 'BackToSelectedHOC';
